import React from 'react';
import { m } from 'framer-motion';
import { CreditCardIcon, ZapIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { BASE_OFFER_CHECKOUT_URL, PREMIUM_OFFER_CHECKOUT_URL } from '../utils/checkout';
const baseRows = [{
  content: 'Colección Didáctica (6 Tomos)',
  value: '59,90€'
}, {
  content: 'Los 5 Bonos Estratégicos',
  value: '59,50€'
}, {
  content: 'Manual de Preparación Física',
  value: '19,90€'
}, {
  content: 'Fichas de Evaluación',
  value: '9,90€'
}];
const premiumRows = [{
  content: 'Colección Completa (6 Tomos)',
  value: '59,90€'
}, {
  content: 'Los 5 Bonos Estratégicos',
  value: '59,50€'
}, {
  content: '[EXCLUSIVO] Cronograma Maestro Anual',
  value: '9,90€'
}, {
  content: '[EXCLUSIVO] Versión Pocket Móvil',
  value: '9,90€'
}];
const trustItems = [{
  icon: CreditCardIcon,
  label: 'Pago único'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 14 días'
}];
export function Pricing() {
  return <section id="oferta-base" className="bg-bg-primary py-10 sm:py-14" data-id="element-232" data-mp="16ka1abk3ofl9">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-233" data-mp="16hx9l6ojiqv0">
        <SectionTag icon="💰" data-id="element-234" data-mp="11lqeya1lh1sd">Oferta Especial</SectionTag>
        <h2 className="mt-4 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-235" data-mp="xjln9gupif8d">
          Elige tu plan y deja de improvisar.
        </h2>
        <p className="mt-3 text-base text-muted sm:text-lg" data-id="element-236" data-mp="1u7i48mu23ck4">
          Ambas opciones incluyen acceso inmediato y garantía total de 14 días.
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-4xl items-start gap-6 px-4 sm:px-6 lg:grid-cols-2" data-id="element-237" data-mp="1l7uyxpy7hmls">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl border border-white/10 bg-bg-secondary p-6 sm:p-7" data-id="element-238" data-mp="1g8rzcl0zw8l7">
          <p className="font-heading text-xs font-semibold uppercase tracking-wider text-muted" data-id="element-239" data-mp="6bbq42r28ctj">
            🏀 Oferta Base
          </p>

          <div className="mt-4 space-y-1.5" data-id="element-240" data-mp="baejgpxogulo">
            {baseRows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-white/5 py-1.5 text-sm" data-id="element-241" data-mp="3tfrig9bt7xx2">
                <span className="text-white/80" data-id="element-242" data-mp="3jq82pcje8k6f">{row.content}</span>
                <span className="flex-shrink-0 text-muted line-through" data-id="element-243" data-mp="3jowyxcpy7cfb">{row.value}</span>
              </div>)}
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-white" data-id="element-244" data-mp="39t283ubkmb1g">
              <span data-id="element-245" data-mp="3er3o26dp9u8p">VALOR TOTAL</span>
              <span data-id="element-246" data-mp="3es6e6c377snk">149,20€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-muted" data-id="element-247" data-mp="30rlyhoskycya">Precio hoy (88% de descuento):</p>
          <p className="font-heading text-4xl font-bold text-orange sm:text-5xl" data-id="element-248" data-mp="35r8axw0l3p61">17,90€</p>

          <div className="mt-5" data-id="element-249" data-mp="2m4n9s1l3xwn9">
            <PrimaryButton fullWidth href={BASE_OFFER_CHECKOUT_URL} data-id="element-250" data-mp="2m5yf45u7bcgh">
              Quiero el Manual Completo
            </PrimaryButton>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-251" data-mp="2v5lfqpf3we8h">
            {trustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-252" data-mp="2r3gjrk16r5io">
                <item.icon size={12} data-id="element-253" data-mp="35398xax2ddoj" /> {item.label}
              </span>)}
          </div>
        </m.div>

        <m.div id="pack-premium" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: 0.08
      }} className="relative rounded-3xl border-2 border-gold bg-bg-secondary p-6 pt-8 shadow-card sm:p-7 sm:pt-9 lg:-translate-y-2" data-id="element-254" data-mp="30450wnlvllzs">
          <span className="absolute -top-3.5 left-1/2 inline-flex -translate-x-1/2 items-center gap-1.5 whitespace-nowrap rounded-full bg-gold px-4 py-1.5 text-[11px] font-heading font-semibold uppercase tracking-wide text-bg-primary" data-id="element-255" data-mp="3ivxvgmglff9m">
            <SparklesIcon size={12} data-id="element-256" data-mp="1m41urq0exf42" /> La opción más elegida
          </span>

          <p className="font-heading text-xs font-semibold uppercase tracking-wider text-gold" data-id="element-257" data-mp="1qvtf3isz6olr">
            🏆 Pack Premium
          </p>

          <div className="mt-4 space-y-1.5" data-id="element-258" data-mp="1uwvdjxf2iwmo">
            {premiumRows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-white/5 py-1.5 text-sm" data-id="element-259" data-mp="y8yy4vvda7d1">
                <span className="text-white/80" data-id="element-260" data-mp="17713toq1po6n">{row.content}</span>
                <span className="flex-shrink-0 text-muted line-through" data-id="element-261" data-mp="1c6x9rtiazpou">{row.value}</span>
              </div>)}
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-white" data-id="element-262" data-mp="2io0u6esu1sy1">
              <span data-id="element-263" data-mp="2nlatqn9xrkzl">VALOR TOTAL</span>
              <span data-id="element-264" data-mp="2nof4k3hwpez8">139,20€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-muted" data-id="element-265" data-mp="2xp7r9ytusbou">Solo 6€ más que la Oferta Base:</p>
          <p className="font-heading text-4xl font-bold text-gold sm:text-5xl" data-id="element-266" data-mp="2ss7ivh9j6wuk">23,90€</p>

          <div className="mt-5" data-id="element-267" data-mp="2nzo4ii30rxop">
            <a href={PREMIUM_OFFER_CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-xl bg-gold px-8 py-4 font-heading text-base font-semibold uppercase tracking-wide text-bg-primary transition-all duration-200 hover:bg-gold/90 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary sm:text-lg" data-id="element-268" data-mp="2nymtuepx1d7i">
              Quiero el Pack Premium
            </a>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-269" data-mp="3a8lwadyffa5">
            {trustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-270" data-mp="3vfcdfpx36niz">
                <item.icon size={12} data-id="element-271" data-mp="1sr42junbhawl" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>

      <p className="mx-auto mt-6 max-w-md px-4 text-center text-xs text-danger sm:text-sm" data-id="element-272" data-mp="1xiueu65te8qn">
        ⏰ Precio de lanzamiento — sube pronto
      </p>
    </section>;
}